import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLazyGetQuestListQuery } from "../../services/apiSlice";
import QuestCard from "../../components/common/Card/CardQuest";
import LoadingCommon from "../../components/common/LoadingStatus/LoadingCommon";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header/Header";
import images from "../../images";
import { useGetUserInfoQuery } from "../../services/apiSlice";
import { TABS } from "../../contanst/tabs";

export default function App() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data: userInfo } = useGetUserInfoQuery();
  useEffect(() => {
    if (userInfo) {
      try {
        // Stringify the userInfo.data to store it in localStorage
        localStorage.setItem("userInfo", JSON.stringify(userInfo.data));
      } catch (error) {
        console.error("Error storing userInfo in localStorage:", error);
      }
    }
  }, [userInfo]);

  const [state] = useState({
    limit: 5,
  });

  const [getOngoing, { data: ongoingData, isFetching: isFetchingOngoing }] =
    useLazyGetQuestListQuery();

  const [
    getCompleted,
    { data: completedData, isFetching: isFetchingCompleted },
  ] = useLazyGetQuestListQuery();

  // Fetch ONGOING and COMPLETED when component loads
  useEffect(() => {
    getOngoing({
      page: 1,
      limit: state.limit,
      status: TABS[1].value, // "PUBLISHED,IN_PROGRESS"
    });
    getCompleted({
      page: 1,
      limit: state.limit,
      status: TABS[2].value, // "COMPLETED"
    });
  }, [getOngoing, getCompleted, state.limit]);

  const ongoingQuests = (ongoingData?.data || []).slice(0, 5);
  const completedQuests = (completedData?.data || []).slice(0, 5);

  return (
    <>
      <LoadingCommon statusLoading={isFetchingOngoing || isFetchingCompleted} />
      <main className="flex flex-col justify-center items-center mx-auto w-full max-w-[480px] bg-gray-100 min-h-screen relative">
        <div className="w-full min-h-[920px]">
          <div className="sticky top-0 left-0 w-full z-50 flex justify-center items-center">
            <Header
              subTitle={userInfo?.data.company_name}
              className={"justify-end max-w-[480px]"}
            />
          </div>
          <div className="flex flex-col mx-auto p-3.5 w-full">
            <div
              onClick={() => navigate("ondemand")}
              className="flex flex-row flex-1 justify-between mt-[15px] w-full bg-[#3F54DF] rounded-lg shadow-[5px_5px_7px_rgba(0,0,80,0.5)] transition-all duration-300 ease-out cursor-pointer hover:scale-[1.02]"
            >
              <div>
                <div className="flex flex-col w-full mt-[15px] ml-[18.46px] font-extrabold text-white">
                  <span className="-tracking-[0.02em] text-2xl">
                    {t("home.hire")} <br />
                    {t("home.mysteryShopper")}
                  </span>
                  <div className="font-bold text-4xl -tracking-[0.02em]">
                    {t("home.homeHeader.onDemand")}
                  </div>
                </div>
              </div>
              <div className="mt-[7px]">
                <img
                  src={images.Demo1Shopper31}
                  alt=""
                  className="object-cover w-[195.19px] h-[188px]"
                />
              </div>
            </div>
          </div>

          {/* Section ONGOING */}
          <div className="flex flex-col mx-auto w-full">
            <div className="flex flex-col flex-1 p-3.5 w-full">
              <div className="flex justify-between items-center text-indigo-600">
                <h2 className="text-lg font-semibold">
                  {t("home.ongoing.title")}
                  <span>
                    {ongoingQuests.length > 0 && (
                      <span>({ongoingQuests.length})</span>
                    )}
                  </span>
                </h2>
                <button
                  onClick={() =>
                    navigate("/quest", {
                      state: { activeTab: TABS[1].value }, // "PUBLISHED,IN_PROGRESS"
                    })
                  }
                  className="px-2.5 py-1.5 text-xs font-bold text-indigo-600"
                >
                  <span>{t("home.seeAll")}</span>
                </button>
              </div>

              {ongoingQuests.length > 0 ? (
                ongoingQuests.map((quest, index) => (
                  <QuestCard
                    key={quest.id || index}
                    {...quest}
                    responses={quest.slot_handle}
                    totalResponses={quest.max_slot}
                    endTime={quest.expire_time}
                    statusText={quest.status_biz}
                    isCompleted={false}
                    handleQRCode={() =>
                      navigate(`/qr-code?id_quest_business=${quest.id}`)
                    }
                    handleView={() => navigate(`/quest/details/${quest.id}`)}
                    handleTaskQuest={() => navigate(`/quest/result`)}
                    handleToPerforman={() => navigate(`/performan`)}
                  />
                ))
              ) : (
                <div className="text-center text-gray-500 py-5">
                  {t("home.noOnGoingQuests")}
                </div>
              )}
            </div>
          </div>

          {/* Section COMPLETED */}
          <div className="flex flex-col mx-auto w-full mt-2">
            <div className="flex flex-col flex-1 p-3.5 w-full">
              <div className="flex justify-between items-center text-indigo-600">
                <h2 className="text-lg font-semibold">
                  {t("base.completed")}
                  <span>
                    {completedQuests.length > 0 && (
                      <span>({completedQuests.length})</span>
                    )}
                  </span>
                </h2>
                <button
                  onClick={() =>
                    navigate("/quest", {
                      state: { activeTab: TABS[2].value }, // "COMPLETED"
                    })
                  }
                  className="px-2.5 py-1.5 text-xs font-bold text-indigo-600"
                >
                  <span>{t("home.seeAll")}</span>
                </button>
              </div>

              {completedQuests.length > 0 ? (
                completedQuests.map((quest, index) => (
                  <QuestCard
                    key={quest.id || index}
                    {...quest}
                    responses={quest.slot_handle}
                    totalResponses={quest.max_slot}
                    endTime={
                      quest.end_time ? quest.end_time : quest.expire_time
                    }
                    statusText={quest.status_biz}
                    isCompleted={quest.status_biz === "COMPLETED"}
                    handleQRCode={() =>
                      navigate(`/qr-code?id_quest_business=${quest.id}`)
                    }
                    handleTaskQuest={() =>
                      navigate(`/quest/details/${quest.id}`)
                    }
                    handleToPerforman={() =>
                      navigate(`/quest/result/${quest.id}`)
                    }
                  />
                ))
              ) : (
                <div className="text-center text-gray-500 py-5">
                  {t("home.noCompletedQuests")}
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
